module.exports = __webpack_public_path__ + "static/media/icon-login.c7d78f53.svg";